/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

import { slideMotion, zoomBigMotion } from "ng-zorro-antd/core/animation";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzSubmenuNoneInlineChildComponent } from "ng-zorro-antd/menu";
import { UiMenuModeType, UiMenuThemeType } from "../../menu.models";

@Component({
  selector: "[ui-submenu-none-inline-child]",
  exportAs: "uiSubmenuNoneInlineChild",
  animations: [zoomBigMotion, slideMotion],
  templateUrl: "./submenu-non-inline-child.component.html",
})
export class UiSubmenuNoneInlineChildComponent extends NzSubmenuNoneInlineChildComponent {
  @Input() public menuClass = "";
  @Input() public theme: UiMenuThemeType = "light";
  @Input() public templateOutlet: TemplateRef<NzSafeAny> | null = null;
  @Input() public isMenuInsideDropDown = false;
  @Input() public mode: UiMenuModeType = "vertical";
  @Input() public position = "right";
  @Input() public nzDisabled = false;
  @Input() public nzOpen = false;
  @Output() public readonly subMenuMouseState = new EventEmitter<boolean>();
}
